import {getUnits} from "../../api/mainpage/units";

const state = () => ({
  units:{},
  newsId: null
})


const getters = {
  get_units(state) {
    return state.units;
  },
}

const mutations = {
  SET_UNITS(state,data){
    state.units = data;}
}

const actions = {
  async fetchUnits({ commit }) {
    try {
      const response = await getUnits();
      commit('SET_UNITS', response.data.results);
    } catch (error) {
      // handle the error here
    }
  },

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
